import { render, staticRenderFns } from "./SkyBox.vue?vue&type=template&id=398a228b&"
import script from "./SkyBox.vue?vue&type=script&lang=js&"
export * from "./SkyBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports